import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import './index.css';
import App from './App.tsx';
import { AuthProvider, configureAmplify } from './features/auth';
import { ErrorBoundary, ToastProvider } from './shared/components';
import { createResponsiveTheme } from './shared/theme';
import { applyGBBrandColors, preloadGBAssets, ensureGBFontsLoaded } from './utils/designAssets';

// Initialize i18n for multi-language support (Requirement 49)
import './i18n/config';

// Initialize AWS Amplify
configureAmplify();

// Initialize GB人材ブランドスタイル
applyGBBrandColors();
preloadGBAssets();
ensureGBFontsLoaded();

// MUI Theme with responsive configuration
// Task 14.1b: Breakpoints - 320px mobile, 768px tablet, 1024px desktop
const theme = createResponsiveTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <ToastProvider>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </ToastProvider>
      </ErrorBoundary>
    </ThemeProvider>
  </StrictMode>
);
